const load = (src) => {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.addEventListener('load', () => {
			resolve(img);
		});
		img.addEventListener('error', () => {
			reject(new Error('Preload Error : ' + src));
		});
		img.src = src;
	});
};

export default async (list) => {
	try {
		const res = await Promise.all(list.map(src => load(src)));
		return res;
	} catch (error) {
		console.log('loader.js error', error);
		return;
	}
};
